import { StatusFormData } from '@modules/settings/SettingsPage/Components/TimeMaterialsTab/Tabs/POTab/ManagePO/ManagePOModal';
import { Endpoint } from '../endpoint';
import { POStatusResponse, POStatusID } from '@business/entities/poStatus';

export function fetchStatuses() {
  return Endpoint.get<POStatusResponse[]>(`@gc/po-status/all`);
}

export function fetchStatus(id: POStatusID) {
  return Endpoint.get<POStatusResponse>(`@gc/po-status/${id}`);
}

export function createStatus(data: any) {
  return Endpoint.post<POStatusResponse>(`@gc/po-status`, { data });
}

export function updateStatus(id: POStatusID, data: Partial<POStatusResponse>) {
  return Endpoint.patch<POStatusResponse[]>(`@gc/po-status/${id}`, { data });
}

export function deleteStatus(id: POStatusID) {
  return Endpoint.delete<void>(`@gc/po-status/${id}`);
}

export function createOrUpdatePOStatus(data: StatusFormData) {
  return Endpoint.post<POStatusResponse[]>(`@gc/po-status/create-or-update`, { data });
}
